// This file is auto-generated by @hey-api/openapi-ts

import {
  createClient,
  createConfig,
  type Options,
  formDataBodySerializer,
} from '@hey-api/client-fetch';
import type {
  ExtractVariablesData,
  ExtractVariablesError,
  ExtractVariablesResponse,
  GenerateAppTemplateData,
  GenerateAppTemplateError,
  GenerateAppTemplateResponse,
  ListMcpServersData,
  ListMcpServersError,
  ListMcpServersResponse2,
  CreateMcpServerData,
  CreateMcpServerError,
  CreateMcpServerResponse,
  UpdateMcpServerData,
  UpdateMcpServerError,
  UpdateMcpServerResponse,
  DeleteMcpServerData,
  DeleteMcpServerError,
  DeleteMcpServerResponse2,
  ValidateMcpServerData,
  ValidateMcpServerError,
  ValidateMcpServerResponse2,
  GetAuthConfigError,
  GetAuthConfigResponse,
  RefreshTokenError,
  RefreshTokenResponse,
  EmailSignupData2,
  EmailSignupError,
  EmailSignupResponse2,
  EmailLoginData2,
  EmailLoginError,
  EmailLoginResponse2,
  CreateVerificationData2,
  CreateVerificationError,
  CreateVerificationResponse2,
  ResendVerificationData,
  ResendVerificationError,
  ResendVerificationResponse,
  CheckVerificationData,
  CheckVerificationError,
  CheckVerificationResponse,
  ListAccountsData,
  ListAccountsError,
  ListAccountsResponse2,
  LogoutError,
  LogoutResponse,
  CheckToolOauthStatusData,
  CheckToolOauthStatusError,
  CheckToolOauthStatusResponse,
  CreateCliApiKeyData2,
  CreateCliApiKeyError,
  CreateCliApiKeyResponse2,
  ListCliApiKeysError,
  ListCliApiKeysResponse2,
  RevokeCliApiKeyData,
  RevokeCliApiKeyError,
  RevokeCliApiKeyResponse,
  UpdateCliApiKeyData,
  UpdateCliApiKeyError,
  UpdateCliApiKeyResponse,
  GetCollabTokenError,
  GetCollabTokenResponse2,
  ListCanvasesData,
  ListCanvasesError,
  ListCanvasesResponse,
  GetCanvasDetailData,
  GetCanvasDetailError,
  GetCanvasDetailResponse2,
  GetCanvasDataData,
  GetCanvasDataError,
  GetCanvasDataResponse2,
  ExportCanvasData,
  ExportCanvasError,
  ExportCanvasResponse2,
  ImportCanvasData,
  ImportCanvasError,
  ImportCanvasResponse,
  CreateCanvasData,
  CreateCanvasError,
  CreateCanvasResponse,
  DuplicateCanvasData,
  DuplicateCanvasError,
  DuplicateCanvasResponse,
  UpdateCanvasData,
  UpdateCanvasError,
  UpdateCanvasResponse,
  DeleteCanvasData,
  DeleteCanvasError,
  DeleteCanvasResponse,
  AutoNameCanvasData,
  AutoNameCanvasError,
  AutoNameCanvasResponse2,
  GetCanvasStateData,
  GetCanvasStateError,
  GetCanvasStateResponse2,
  SetCanvasStateData,
  SetCanvasStateError,
  SetCanvasStateResponse,
  GetCanvasTransactionsData,
  GetCanvasTransactionsError,
  GetCanvasTransactionsResponse2,
  SyncCanvasStateData,
  SyncCanvasStateError,
  SyncCanvasStateResponse2,
  CreateCanvasVersionData,
  CreateCanvasVersionError,
  CreateCanvasVersionResponse2,
  GetWorkflowVariablesData,
  GetWorkflowVariablesError,
  GetWorkflowVariablesResponse2,
  UpdateWorkflowVariablesData,
  UpdateWorkflowVariablesError,
  UpdateWorkflowVariablesResponse2,
  ListDriveFilesData,
  ListDriveFilesError,
  ListDriveFilesResponse2,
  CreateDriveFileData,
  CreateDriveFileError,
  CreateDriveFileResponse,
  BatchCreateDriveFilesData,
  BatchCreateDriveFilesError,
  BatchCreateDriveFilesResponse2,
  UpdateDriveFileData,
  UpdateDriveFileError,
  UpdateDriveFileResponse,
  DeleteDriveFileData,
  DeleteDriveFileError,
  DeleteDriveFileResponse,
  ListCanvasTemplatesData,
  ListCanvasTemplatesError,
  ListCanvasTemplatesResponse,
  CreateCanvasTemplateData,
  CreateCanvasTemplateError,
  CreateCanvasTemplateResponse,
  UpdateCanvasTemplateData,
  UpdateCanvasTemplateError,
  UpdateCanvasTemplateResponse,
  ListCanvasTemplateCategoriesError,
  ListCanvasTemplateCategoriesResponse,
  ListResourcesData,
  ListResourcesError,
  ListResourcesResponse,
  GetResourceDetailData,
  GetResourceDetailError,
  GetResourceDetailResponse2,
  UpdateResourceData,
  UpdateResourceError,
  UpdateResourceResponse,
  CreateResourceData,
  CreateResourceError,
  CreateResourceResponse,
  CreateResourceWithFileData,
  CreateResourceWithFileError,
  CreateResourceWithFileResponse,
  BatchCreateResourceData,
  BatchCreateResourceError,
  BatchCreateResourceResponse2,
  ReindexResourceData,
  ReindexResourceError,
  ReindexResourceResponse2,
  DeleteResourceData,
  DeleteResourceError,
  DeleteResourceResponse,
  ListDocumentsData,
  ListDocumentsError,
  ListDocumentsResponse,
  GetDocumentDetailData,
  GetDocumentDetailError,
  GetDocumentDetailResponse2,
  ExportDocumentData,
  ExportDocumentError,
  ExportDocumentResponse,
  StartExportJobData,
  StartExportJobError,
  StartExportJobResponse2,
  GetExportJobStatusData,
  GetExportJobStatusError,
  GetExportJobStatusResponse2,
  DownloadExportJobResultData,
  DownloadExportJobResultError,
  DownloadExportJobResultResponse,
  UpdateDocumentData,
  UpdateDocumentError,
  UpdateDocumentResponse,
  CreateDocumentData,
  CreateDocumentError,
  CreateDocumentResponse,
  DeleteDocumentData,
  DeleteDocumentError,
  DeleteDocumentResponse,
  BatchUpdateDocumentData,
  BatchUpdateDocumentError,
  BatchUpdateDocumentResponse,
  ListCodeArtifactsData,
  ListCodeArtifactsError,
  ListCodeArtifactsResponse,
  GetCodeArtifactDetailData,
  GetCodeArtifactDetailError,
  GetCodeArtifactDetailResponse2,
  CreateCodeArtifactData,
  CreateCodeArtifactError,
  CreateCodeArtifactResponse,
  UpdateCodeArtifactData,
  UpdateCodeArtifactError,
  UpdateCodeArtifactResponse,
  CreateShareData,
  CreateShareError,
  CreateShareResponse2,
  ListSharesData,
  ListSharesError,
  ListSharesResponse,
  DeleteShareData,
  DeleteShareError,
  DeleteShareResponse,
  DuplicateShareData,
  DuplicateShareError,
  DuplicateShareResponse2,
  GetActionResultData,
  GetActionResultError,
  GetActionResultResponse2,
  AbortActionData,
  AbortActionError,
  AbortActionResponse,
  InvokeSkillData,
  InvokeSkillError,
  InvokeSkillResponse2,
  StreamInvokeSkillData,
  StreamInvokeSkillError,
  StreamInvokeSkillResponse,
  GenerateMediaData,
  GenerateMediaError,
  GenerateMediaResponse,
  ListCopilotSessionsData,
  ListCopilotSessionsError,
  ListCopilotSessionsResponse2,
  GetCopilotSessionDetailData,
  GetCopilotSessionDetailError,
  GetCopilotSessionDetailResponse2,
  InitializeWorkflowData,
  InitializeWorkflowError,
  InitializeWorkflowResponse2,
  AbortWorkflowData,
  AbortWorkflowError,
  AbortWorkflowResponse,
  ListWorkflowExecutionsData,
  ListWorkflowExecutionsError,
  ListWorkflowExecutionsResponse2,
  GetWorkflowDetailData,
  GetWorkflowDetailError,
  GetWorkflowDetailResponse2,
  GetWorkflowPlanDetailData,
  GetWorkflowPlanDetailError,
  GetWorkflowPlanDetailResponse2,
  CreateWorkflowAppData,
  CreateWorkflowAppError,
  CreateWorkflowAppResponse2,
  DeleteWorkflowAppData,
  DeleteWorkflowAppError,
  DeleteWorkflowAppResponse,
  GetWorkflowAppDetailData,
  GetWorkflowAppDetailError,
  GetWorkflowAppDetailResponse2,
  ExecuteWorkflowAppData,
  ExecuteWorkflowAppError,
  ExecuteWorkflowAppResponse2,
  ListWorkflowAppsData,
  ListWorkflowAppsError,
  ListWorkflowAppsResponse2,
  GetTemplateGenerationStatusData,
  GetTemplateGenerationStatusError,
  GetTemplateGenerationStatusResponse2,
  CreateScheduleData,
  CreateScheduleError,
  CreateScheduleResponse2,
  UpdateScheduleData,
  UpdateScheduleError,
  UpdateScheduleResponse2,
  DeleteScheduleData,
  DeleteScheduleError,
  DeleteScheduleResponse2,
  ListSchedulesData,
  ListSchedulesError,
  ListSchedulesResponse2,
  GetScheduleDetailData,
  GetScheduleDetailError,
  GetScheduleDetailResponse2,
  GetScheduleRecordsData,
  GetScheduleRecordsError,
  GetScheduleRecordsResponse2,
  ListAllScheduleRecordsData,
  ListAllScheduleRecordsError,
  ListAllScheduleRecordsResponse2,
  GetAvailableToolsError,
  GetAvailableToolsResponse2,
  GetScheduleRecordDetailData,
  GetScheduleRecordDetailError,
  GetScheduleRecordDetailResponse2,
  GetRecordSnapshotData,
  GetRecordSnapshotError,
  GetRecordSnapshotResponse2,
  TriggerScheduleManuallyData,
  TriggerScheduleManuallyError,
  TriggerScheduleManuallyResponse2,
  RetryScheduleRecordData,
  RetryScheduleRecordError,
  RetryScheduleRecordResponse2,
  EnableWebhookData,
  EnableWebhookError,
  EnableWebhookResponse2,
  DisableWebhookData,
  DisableWebhookError,
  DisableWebhookResponse,
  ResetWebhookData,
  ResetWebhookError,
  ResetWebhookResponse2,
  UpdateWebhookData,
  UpdateWebhookError,
  UpdateWebhookResponse,
  GetWebhookConfigData,
  GetWebhookConfigError,
  GetWebhookConfigResponse2,
  GetWebhookHistoryData,
  GetWebhookHistoryError,
  GetWebhookHistoryResponse2,
  RunWebhookData,
  RunWebhookError,
  RunWebhookResponse,
  GetOpenapiConfigData,
  GetOpenapiConfigError,
  GetOpenapiConfigResponse,
  UpdateOpenapiConfigData,
  UpdateOpenapiConfigError,
  UpdateOpenapiConfigResponse,
  UploadOpenapiFilesData,
  UploadOpenapiFilesError,
  UploadOpenapiFilesResponse,
  SearchWorkflowsViaApiData,
  SearchWorkflowsViaApiError,
  SearchWorkflowsViaApiResponse,
  GetWorkflowDetailViaApiData,
  GetWorkflowDetailViaApiError,
  GetWorkflowDetailViaApiResponse,
  RunWorkflowViaApiData,
  RunWorkflowViaApiError,
  RunWorkflowViaApiResponse,
  GenerateWorkflowViaCopilotData,
  GenerateWorkflowViaCopilotError,
  GenerateWorkflowViaCopilotResponse,
  GetWorkflowStatusViaApiData,
  GetWorkflowStatusViaApiError,
  GetWorkflowStatusViaApiResponse2,
  GetWorkflowOutputData,
  GetWorkflowOutputError,
  GetWorkflowOutputResponse2,
  AbortWorkflowViaApiData,
  AbortWorkflowViaApiError,
  AbortWorkflowViaApiResponse,
  GetSettingsError,
  GetSettingsResponse,
  UpdateSettingsData,
  UpdateSettingsError,
  UpdateSettingsResponse,
  CheckSettingsFieldData,
  CheckSettingsFieldError,
  CheckSettingsFieldResponse2,
  GetFormDefinitionError,
  GetFormDefinitionResponse2,
  SubmitFormData,
  SubmitFormError,
  SubmitFormResponse,
  GetCreditRechargeData,
  GetCreditRechargeError,
  GetCreditRechargeResponse2,
  GetCreditUsageData,
  GetCreditUsageError,
  GetCreditUsageResponse2,
  GetCreditBalanceError,
  GetCreditBalanceResponse,
  GetCreditUsageByResultIdData,
  GetCreditUsageByResultIdError,
  GetCreditUsageByResultIdResponse2,
  GetCreditUsageByExecutionIdData,
  GetCreditUsageByExecutionIdError,
  GetCreditUsageByExecutionIdResponse2,
  GetCreditUsageByCanvasIdData,
  GetCreditUsageByCanvasIdError,
  GetCreditUsageByCanvasIdResponse2,
  GetCanvasCommissionByCanvasIdData,
  GetCanvasCommissionByCanvasIdError,
  GetCanvasCommissionByCanvasIdResponse2,
  ListInvitationCodesError,
  ListInvitationCodesResponse2,
  ActivateInvitationCodeData,
  ActivateInvitationCodeError,
  ActivateInvitationCodeResponse,
  SkipInvitationCodeError,
  SkipInvitationCodeResponse,
  GetSubscriptionPlansError,
  GetSubscriptionPlansResponse2,
  GetSubscriptionUsageError,
  GetSubscriptionUsageResponse2,
  ListModelsError,
  ListModelsResponse2,
  CreateCheckoutSessionData,
  CreateCheckoutSessionError,
  CreateCheckoutSessionResponse2,
  CreateCreditPackCheckoutSessionData,
  CreateCreditPackCheckoutSessionError,
  CreateCreditPackCheckoutSessionResponse,
  CreatePortalSessionError,
  CreatePortalSessionResponse2,
  SearchData,
  SearchError,
  SearchResponse2,
  MultiLingualWebSearchData,
  MultiLingualWebSearchError,
  MultiLingualWebSearchResponse2,
  ListProvidersData,
  ListProvidersError,
  ListProvidersResponse2,
  CreateProviderData,
  CreateProviderError,
  CreateProviderResponse,
  UpdateProviderData,
  UpdateProviderError,
  UpdateProviderResponse,
  DeleteProviderData,
  DeleteProviderError,
  DeleteProviderResponse,
  TestProviderConnectionData,
  TestProviderConnectionError,
  TestProviderConnectionResponse2,
  ListProviderItemsData,
  ListProviderItemsError,
  ListProviderItemsResponse2,
  ListProviderItemOptionsData,
  ListProviderItemOptionsError,
  ListProviderItemOptionsResponse2,
  CreateProviderItemData,
  CreateProviderItemError,
  CreateProviderItemResponse,
  BatchCreateProviderItemsData,
  BatchCreateProviderItemsError,
  BatchCreateProviderItemsResponse,
  UpdateProviderItemData,
  UpdateProviderItemError,
  UpdateProviderItemResponse,
  BatchUpdateProviderItemsData,
  BatchUpdateProviderItemsError,
  BatchUpdateProviderItemsResponse,
  DeleteProviderItemData,
  DeleteProviderItemError,
  DeleteProviderItemResponse,
  ListToolsData,
  ListToolsError,
  ListToolsResponse2,
  ListUserToolsError,
  ListUserToolsResponse2,
  ListToolsetInventoryError,
  ListToolsetInventoryResponse2,
  ListToolsetsData,
  ListToolsetsError,
  ListToolsetsResponse2,
  CreateToolsetData,
  CreateToolsetError,
  CreateToolsetResponse,
  UpdateToolsetData,
  UpdateToolsetError,
  UpdateToolsetResponse,
  DeleteToolsetData,
  DeleteToolsetError,
  DeleteToolsetResponse,
  ExportToolsetDefinitionsData,
  ExportToolsetDefinitionsError,
  ExportToolsetDefinitionsResponse2,
  ExecuteToolData,
  ExecuteToolError,
  ExecuteToolResponse2,
  GetToolCallResultData,
  GetToolCallResultError,
  GetToolCallResultResponse2,
  AuthorizeComposioConnectionData,
  AuthorizeComposioConnectionError,
  AuthorizeComposioConnectionResponse,
  RevokeComposioConnectionData,
  RevokeComposioConnectionError,
  RevokeComposioConnectionResponse,
  GetComposioConnectionStatusData,
  GetComposioConnectionStatusError,
  GetComposioConnectionStatusResponse,
  ScrapeData,
  ScrapeError,
  ScrapeResponse,
  UploadData,
  UploadError,
  UploadResponse2,
  ServeStaticError,
  ServeStaticResponse,
  ConvertData,
  ConvertError,
  ConvertResponse2,
  GetPromptSuggestionsError,
  GetPromptSuggestionsResponse2,
  GetAvailableVouchersError,
  GetAvailableVouchersResponse2,
  ListUserVouchersError,
  ListUserVouchersResponse2,
  ValidateVoucherData,
  ValidateVoucherError,
  ValidateVoucherResponse2,
  CreateVoucherInvitationData,
  CreateVoucherInvitationError,
  CreateVoucherInvitationResponse2,
  VerifyVoucherInvitationData,
  VerifyVoucherInvitationError,
  VerifyVoucherInvitationResponse2,
  ClaimVoucherInvitationData,
  ClaimVoucherInvitationError,
  ClaimVoucherInvitationResponse2,
  TriggerVoucherData,
  TriggerVoucherError,
  TriggerVoucherResponse2,
} from './types.gen';

export const client = createClient(createConfig());

/**
 * Extract variables from prompt
 * Unified variable extraction interface that supports two modes:
 * - 'direct': Directly update Canvas variables
 * - 'candidate': Return candidate solutions for user selection
 *
 * This endpoint analyzes natural language prompts and extracts workflow variables
 * based on the context of existing Canvas variables and content.
 *
 */
export const extractVariables = <ThrowOnError extends boolean = false>(
  options: Options<ExtractVariablesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ExtractVariablesResponse,
    ExtractVariablesError,
    ThrowOnError
  >({
    ...options,
    url: '/variable-extraction/extract',
  });
};

/**
 * Generate APP publish template
 * Generate a user intent template based on all original prompts and variables in a Canvas.
 * This endpoint analyzes the Canvas content and creates a template with placeholders
 * that can be used for APP publishing and user interaction.
 *
 */
export const generateAppTemplate = <ThrowOnError extends boolean = false>(
  options: Options<GenerateAppTemplateData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GenerateAppTemplateResponse,
    GenerateAppTemplateError,
    ThrowOnError
  >({
    ...options,
    url: '/variable-extraction/generate-template',
  });
};

/**
 * List MCP servers
 * List all MCP servers for a user
 */
export const listMcpServers = <ThrowOnError extends boolean = false>(
  options?: Options<ListMcpServersData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListMcpServersResponse2,
    ListMcpServersError,
    ThrowOnError
  >({
    ...options,
    url: '/mcp-server/list',
  });
};

/**
 * Create MCP server
 * Create a new MCP server
 */
export const createMcpServer = <ThrowOnError extends boolean = false>(
  options: Options<CreateMcpServerData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateMcpServerResponse,
    CreateMcpServerError,
    ThrowOnError
  >({
    ...options,
    url: '/mcp-server/create',
  });
};

/**
 * Update MCP server
 * Update an existing MCP server
 */
export const updateMcpServer = <ThrowOnError extends boolean = false>(
  options: Options<UpdateMcpServerData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateMcpServerResponse,
    UpdateMcpServerError,
    ThrowOnError
  >({
    ...options,
    url: '/mcp-server/update',
  });
};

/**
 * Delete MCP server
 * Delete an existing MCP server
 */
export const deleteMcpServer = <ThrowOnError extends boolean = false>(
  options: Options<DeleteMcpServerData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteMcpServerResponse2,
    DeleteMcpServerError,
    ThrowOnError
  >({
    ...options,
    url: '/mcp-server/delete',
  });
};

/**
 * Validate MCP server
 * Validate MCP server configuration
 */
export const validateMcpServer = <ThrowOnError extends boolean = false>(
  options: Options<ValidateMcpServerData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ValidateMcpServerResponse2,
    ValidateMcpServerError,
    ThrowOnError
  >({
    ...options,
    url: '/mcp-server/validate',
  });
};

/**
 * Get auth config
 * Get auth config
 */
export const getAuthConfig = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetAuthConfigResponse, GetAuthConfigError, ThrowOnError>({
    ...options,
    url: '/auth/config',
  });
};

/**
 * Refresh token
 * Refresh token
 */
export const refreshToken = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<RefreshTokenResponse, RefreshTokenError, ThrowOnError>({
    ...options,
    url: '/auth/refreshToken',
  });
};

/**
 * Sign up with email
 * Sign up with email
 */
export const emailSignup = <ThrowOnError extends boolean = false>(
  options: Options<EmailSignupData2, ThrowOnError>,
) => {
  return (options?.client ?? client).post<EmailSignupResponse2, EmailSignupError, ThrowOnError>({
    ...options,
    url: '/auth/email/signup',
  });
};

/**
 * Login with email
 * Login with email
 */
export const emailLogin = <ThrowOnError extends boolean = false>(
  options: Options<EmailLoginData2, ThrowOnError>,
) => {
  return (options?.client ?? client).post<EmailLoginResponse2, EmailLoginError, ThrowOnError>({
    ...options,
    url: '/auth/email/login',
  });
};

/**
 * Create verification session
 * Create a verification session
 */
export const createVerification = <ThrowOnError extends boolean = false>(
  options: Options<CreateVerificationData2, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateVerificationResponse2,
    CreateVerificationError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/verification/create',
  });
};

/**
 * Resend verification
 * Resend verification
 */
export const resendVerification = <ThrowOnError extends boolean = false>(
  options: Options<ResendVerificationData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ResendVerificationResponse,
    ResendVerificationError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/verification/resend',
  });
};

/**
 * Verify authentication session
 * Verify account creation
 */
export const checkVerification = <ThrowOnError extends boolean = false>(
  options: Options<CheckVerificationData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CheckVerificationResponse,
    CheckVerificationError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/verification/check',
  });
};

/**
 * List auth accounts
 * List auth accounts
 */
export const listAccounts = <ThrowOnError extends boolean = false>(
  options?: Options<ListAccountsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListAccountsResponse2, ListAccountsError, ThrowOnError>({
    ...options,
    url: '/auth/account/list',
  });
};

/**
 * Logout
 * Logout
 */
export const logout = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<LogoutResponse, LogoutError, ThrowOnError>({
    ...options,
    url: '/auth/logout',
  });
};

/**
 * Check tool OAuth status
 * Check if user has OAuth authorization for specific provider and scopes
 */
export const checkToolOauthStatus = <ThrowOnError extends boolean = false>(
  options: Options<CheckToolOauthStatusData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    CheckToolOauthStatusResponse,
    CheckToolOauthStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/tool-oauth/status',
  });
};

/**
 * Create CLI API key
 * Create a new API key for CLI authentication
 */
export const createCliApiKey = <ThrowOnError extends boolean = false>(
  options: Options<CreateCliApiKeyData2, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateCliApiKeyResponse2,
    CreateCliApiKeyError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/cli/api-key',
  });
};

/**
 * List CLI API keys
 * List API keys for current user
 */
export const listCliApiKeys = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListCliApiKeysResponse2,
    ListCliApiKeysError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/cli/api-key',
  });
};

/**
 * Revoke CLI API key
 * Revoke API key by ID
 */
export const revokeCliApiKey = <ThrowOnError extends boolean = false>(
  options: Options<RevokeCliApiKeyData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    RevokeCliApiKeyResponse,
    RevokeCliApiKeyError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/cli/api-key/{keyId}',
  });
};

/**
 * Update CLI API key
 * Update API key name
 */
export const updateCliApiKey = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCliApiKeyData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UpdateCliApiKeyResponse,
    UpdateCliApiKeyError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/cli/api-key/{keyId}',
  });
};

/**
 * Get collab token
 * Get collab token
 */
export const getCollabToken = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCollabTokenResponse2,
    GetCollabTokenError,
    ThrowOnError
  >({
    ...options,
    url: '/collab/getToken',
  });
};

/**
 * List user canvases
 * List all canvases for a user
 */
export const listCanvases = <ThrowOnError extends boolean = false>(
  options?: Options<ListCanvasesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListCanvasesResponse, ListCanvasesError, ThrowOnError>({
    ...options,
    url: '/canvas/list',
  });
};

/**
 * Get canvas detail
 * Get canvas detail
 */
export const getCanvasDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetCanvasDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCanvasDetailResponse2,
    GetCanvasDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/detail',
  });
};

/**
 * Get canvas data
 * Get public canvas data without checking user identity
 */
export const getCanvasData = <ThrowOnError extends boolean = false>(
  options: Options<GetCanvasDataData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetCanvasDataResponse2, GetCanvasDataError, ThrowOnError>({
    ...options,
    url: '/canvas/data',
  });
};

/**
 * Export canvas
 * Export canvas
 */
export const exportCanvas = <ThrowOnError extends boolean = false>(
  options: Options<ExportCanvasData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ExportCanvasResponse2, ExportCanvasError, ThrowOnError>({
    ...options,
    url: '/canvas/export',
  });
};

/**
 * Import canvas
 * Import canvas
 */
export const importCanvas = <ThrowOnError extends boolean = false>(
  options: Options<ImportCanvasData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<ImportCanvasResponse, ImportCanvasError, ThrowOnError>({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
    url: '/canvas/import',
  });
};

/**
 * Create canvas
 * Create a new canvas
 */
export const createCanvas = <ThrowOnError extends boolean = false>(
  options: Options<CreateCanvasData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<CreateCanvasResponse, CreateCanvasError, ThrowOnError>({
    ...options,
    url: '/canvas/create',
  });
};

/**
 * Duplicate canvas
 * Duplicate an existing canvas
 */
export const duplicateCanvas = <ThrowOnError extends boolean = false>(
  options: Options<DuplicateCanvasData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DuplicateCanvasResponse,
    DuplicateCanvasError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/duplicate',
  });
};

/**
 * Update canvas
 * Update an existing canvas
 */
export const updateCanvas = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCanvasData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<UpdateCanvasResponse, UpdateCanvasError, ThrowOnError>({
    ...options,
    url: '/canvas/update',
  });
};

/**
 * Delete canvas
 * Delete an existing canvas
 */
export const deleteCanvas = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCanvasData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<DeleteCanvasResponse, DeleteCanvasError, ThrowOnError>({
    ...options,
    url: '/canvas/delete',
  });
};

/**
 * Auto name canvas
 * Auto name a canvas
 */
export const autoNameCanvas = <ThrowOnError extends boolean = false>(
  options: Options<AutoNameCanvasData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    AutoNameCanvasResponse2,
    AutoNameCanvasError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/autoName',
  });
};

/**
 * Get canvas state
 * Get canvas state
 */
export const getCanvasState = <ThrowOnError extends boolean = false>(
  options: Options<GetCanvasStateData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCanvasStateResponse2,
    GetCanvasStateError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/getState',
  });
};

/**
 * Set canvas state
 * Set canvas state, should only be used in conflict resolution
 */
export const setCanvasState = <ThrowOnError extends boolean = false>(
  options: Options<SetCanvasStateData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    SetCanvasStateResponse,
    SetCanvasStateError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/setState',
  });
};

/**
 * Get canvas transactions
 * Get canvas transactions
 */
export const getCanvasTransactions = <ThrowOnError extends boolean = false>(
  options: Options<GetCanvasTransactionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCanvasTransactionsResponse2,
    GetCanvasTransactionsError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/getTx',
  });
};

/**
 * Sync canvas state
 * Sync canvas state
 */
export const syncCanvasState = <ThrowOnError extends boolean = false>(
  options: Options<SyncCanvasStateData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    SyncCanvasStateResponse2,
    SyncCanvasStateError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/syncState',
  });
};

/**
 * Create canvas version
 * Create a new canvas version
 */
export const createCanvasVersion = <ThrowOnError extends boolean = false>(
  options: Options<CreateCanvasVersionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateCanvasVersionResponse2,
    CreateCanvasVersionError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/createVersion',
  });
};

/**
 * Get workflow variables
 * Get workflow variables for a canvas
 */
export const getWorkflowVariables = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowVariablesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWorkflowVariablesResponse2,
    GetWorkflowVariablesError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/workflow/variables',
  });
};

/**
 * Update workflow variables
 * Update workflow variables for a canvas
 */
export const updateWorkflowVariables = <ThrowOnError extends boolean = false>(
  options: Options<UpdateWorkflowVariablesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateWorkflowVariablesResponse2,
    UpdateWorkflowVariablesError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/workflow/variables',
  });
};

/**
 * List drive files
 * List all drive files
 */
export const listDriveFiles = <ThrowOnError extends boolean = false>(
  options: Options<ListDriveFilesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListDriveFilesResponse2,
    ListDriveFilesError,
    ThrowOnError
  >({
    ...options,
    url: '/drive/file/list',
  });
};

/**
 * Create drive file
 * Create a new drive file
 */
export const createDriveFile = <ThrowOnError extends boolean = false>(
  options: Options<CreateDriveFileData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateDriveFileResponse,
    CreateDriveFileError,
    ThrowOnError
  >({
    ...options,
    url: '/drive/file/create',
  });
};

/**
 * Batch create drive files
 * Batch create drive files
 */
export const batchCreateDriveFiles = <ThrowOnError extends boolean = false>(
  options: Options<BatchCreateDriveFilesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BatchCreateDriveFilesResponse2,
    BatchCreateDriveFilesError,
    ThrowOnError
  >({
    ...options,
    url: '/drive/file/batchCreate',
  });
};

/**
 * Update drive file
 * Update an existing drive file
 */
export const updateDriveFile = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDriveFileData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateDriveFileResponse,
    UpdateDriveFileError,
    ThrowOnError
  >({
    ...options,
    url: '/drive/file/update',
  });
};

/**
 * Delete drive file
 * Delete an existing drive file
 */
export const deleteDriveFile = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDriveFileData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteDriveFileResponse,
    DeleteDriveFileError,
    ThrowOnError
  >({
    ...options,
    url: '/drive/file/delete',
  });
};

/**
 * List canvas templates
 * List all canvas templates
 */
export const listCanvasTemplates = <ThrowOnError extends boolean = false>(
  options?: Options<ListCanvasTemplatesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListCanvasTemplatesResponse,
    ListCanvasTemplatesError,
    ThrowOnError
  >({
    ...options,
    url: '/template/list',
  });
};

/**
 * Create canvas template
 * Create a new canvas template
 */
export const createCanvasTemplate = <ThrowOnError extends boolean = false>(
  options: Options<CreateCanvasTemplateData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateCanvasTemplateResponse,
    CreateCanvasTemplateError,
    ThrowOnError
  >({
    ...options,
    url: '/template/create',
  });
};

/**
 * Update canvas template
 * Update an existing canvas template
 */
export const updateCanvasTemplate = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCanvasTemplateData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateCanvasTemplateResponse,
    UpdateCanvasTemplateError,
    ThrowOnError
  >({
    ...options,
    url: '/template/update',
  });
};

/**
 * List canvas template categories
 * List all canvas template categories
 */
export const listCanvasTemplateCategories = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListCanvasTemplateCategoriesResponse,
    ListCanvasTemplateCategoriesError,
    ThrowOnError
  >({
    ...options,
    url: '/template/category/list',
  });
};

/**
 * List resources
 * List all resources
 */
export const listResources = <ThrowOnError extends boolean = false>(
  options?: Options<ListResourcesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListResourcesResponse, ListResourcesError, ThrowOnError>({
    ...options,
    url: '/knowledge/resource/list',
  });
};

/**
 * Get resource detail
 * Return resource detail along with its document content
 */
export const getResourceDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetResourceDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetResourceDetailResponse2,
    GetResourceDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/resource/detail',
  });
};

/**
 * Update resource
 * Update an existing resource
 */
export const updateResource = <ThrowOnError extends boolean = false>(
  options: Options<UpdateResourceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateResourceResponse,
    UpdateResourceError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/resource/update',
  });
};

/**
 * Create new resource
 * Create a new resource
 */
export const createResource = <ThrowOnError extends boolean = false>(
  options: Options<CreateResourceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateResourceResponse,
    CreateResourceError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/resource/create',
  });
};

/**
 * Create new resource with file upload
 * Create a new resource with file upload in a single request
 */
export const createResourceWithFile = <ThrowOnError extends boolean = false>(
  options: Options<CreateResourceWithFileData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateResourceWithFileResponse,
    CreateResourceWithFileError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
    url: '/knowledge/resource/createWithFile',
  });
};

/**
 * Batch create new resources
 * Batch create a new resource
 */
export const batchCreateResource = <ThrowOnError extends boolean = false>(
  options: Options<BatchCreateResourceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BatchCreateResourceResponse2,
    BatchCreateResourceError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/resource/batchCreate',
  });
};

/**
 * Reindex resource
 * Reindex an existing resource
 */
export const reindexResource = <ThrowOnError extends boolean = false>(
  options: Options<ReindexResourceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ReindexResourceResponse2,
    ReindexResourceError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/resource/reindex',
  });
};

/**
 * Delete resource
 * Delete an existing resource
 */
export const deleteResource = <ThrowOnError extends boolean = false>(
  options: Options<DeleteResourceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteResourceResponse,
    DeleteResourceError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/resource/delete',
  });
};

/**
 * List user documents
 * List all documents for a user
 */
export const listDocuments = <ThrowOnError extends boolean = false>(
  options?: Options<ListDocumentsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListDocumentsResponse, ListDocumentsError, ThrowOnError>({
    ...options,
    url: '/knowledge/document/list',
  });
};

/**
 * Get canvas detail
 * Return document detail
 */
export const getDocumentDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetDocumentDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetDocumentDetailResponse2,
    GetDocumentDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/document/detail',
  });
};

/**
 * Export document to Markdown, DOCX or PDF format
 * Export a document to Markdown, DOCX or PDF format
 */
export const exportDocument = <ThrowOnError extends boolean = false>(
  options: Options<ExportDocumentData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ExportDocumentResponse, ExportDocumentError, ThrowOnError>(
    {
      ...options,
      url: '/drive/document/export',
    },
  );
};

/**
 * Start async document export
 * Start an asynchronous document export job using Lambda. Use this for binary files (docx, pdf) that need format conversion.
 */
export const startExportJob = <ThrowOnError extends boolean = false>(
  options: Options<StartExportJobData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    StartExportJobResponse2,
    StartExportJobError,
    ThrowOnError
  >({
    ...options,
    url: '/drive/document/export/async',
  });
};

/**
 * Get export job status
 * Get the status of an async export job
 */
export const getExportJobStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetExportJobStatusData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetExportJobStatusResponse2,
    GetExportJobStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/drive/document/export/job/{jobId}',
  });
};

/**
 * Download export job result
 * Download the result of a completed export job
 */
export const downloadExportJobResult = <ThrowOnError extends boolean = false>(
  options: Options<DownloadExportJobResultData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    DownloadExportJobResultResponse,
    DownloadExportJobResultError,
    ThrowOnError
  >({
    ...options,
    url: '/drive/document/export/job/{jobId}/download',
  });
};

/**
 * Update canvas
 * Update an existing document
 */
export const updateDocument = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDocumentData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateDocumentResponse,
    UpdateDocumentError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/document/update',
  });
};

/**
 * Create new canvas
 * Create a new document
 */
export const createDocument = <ThrowOnError extends boolean = false>(
  options: Options<CreateDocumentData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateDocumentResponse,
    CreateDocumentError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/document/create',
  });
};

/**
 * Delete canvas
 * Delete an existing document
 */
export const deleteDocument = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDocumentData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteDocumentResponse,
    DeleteDocumentError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/document/delete',
  });
};

/**
 * Batch update documents
 * Batch update existing documents
 */
export const batchUpdateDocument = <ThrowOnError extends boolean = false>(
  options: Options<BatchUpdateDocumentData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BatchUpdateDocumentResponse,
    BatchUpdateDocumentError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/document/batchUpdate',
  });
};

/**
 * List code artifacts
 * List all code artifacts
 */
export const listCodeArtifacts = <ThrowOnError extends boolean = false>(
  options?: Options<ListCodeArtifactsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListCodeArtifactsResponse,
    ListCodeArtifactsError,
    ThrowOnError
  >({
    ...options,
    url: '/codeArtifact/list',
  });
};

/**
 * Get code artifact detail
 * Get code artifact detail by artifact ID
 */
export const getCodeArtifactDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetCodeArtifactDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCodeArtifactDetailResponse2,
    GetCodeArtifactDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/codeArtifact/detail',
  });
};

/**
 * Create code artifact
 * Create new code artifact
 */
export const createCodeArtifact = <ThrowOnError extends boolean = false>(
  options: Options<CreateCodeArtifactData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateCodeArtifactResponse,
    CreateCodeArtifactError,
    ThrowOnError
  >({
    ...options,
    url: '/codeArtifact/new',
  });
};

/**
 * Update code artifact
 * Update code artifact by artifact ID
 */
export const updateCodeArtifact = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCodeArtifactData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateCodeArtifactResponse,
    UpdateCodeArtifactError,
    ThrowOnError
  >({
    ...options,
    url: '/codeArtifact/update',
  });
};

/**
 * Create share
 * Create new share for canvas
 */
export const createShare = <ThrowOnError extends boolean = false>(
  options: Options<CreateShareData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<CreateShareResponse2, CreateShareError, ThrowOnError>({
    ...options,
    url: '/share/new',
  });
};

/**
 * List shares
 * List all shares
 */
export const listShares = <ThrowOnError extends boolean = false>(
  options?: Options<ListSharesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListSharesResponse, ListSharesError, ThrowOnError>({
    ...options,
    url: '/share/list',
  });
};

/**
 * Delete share
 * Delete an existing share
 */
export const deleteShare = <ThrowOnError extends boolean = false>(
  options: Options<DeleteShareData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<DeleteShareResponse, DeleteShareError, ThrowOnError>({
    ...options,
    url: '/share/delete',
  });
};

/**
 * Duplicate share
 * Duplicate an existing share
 */
export const duplicateShare = <ThrowOnError extends boolean = false>(
  options: Options<DuplicateShareData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DuplicateShareResponse2,
    DuplicateShareError,
    ThrowOnError
  >({
    ...options,
    url: '/share/duplicate',
  });
};

/**
 * Get action result
 * Get action result by result ID
 */
export const getActionResult = <ThrowOnError extends boolean = false>(
  options: Options<GetActionResultData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetActionResultResponse2,
    GetActionResultError,
    ThrowOnError
  >({
    ...options,
    url: '/action/result',
  });
};

/**
 * Abort action
 * Abort an action
 */
export const abortAction = <ThrowOnError extends boolean = false>(
  options: Options<AbortActionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<AbortActionResponse, AbortActionError, ThrowOnError>({
    ...options,
    url: '/action/abort',
  });
};

/**
 * Invoke skill
 * Invoke a skill
 */
export const invokeSkill = <ThrowOnError extends boolean = false>(
  options: Options<InvokeSkillData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<InvokeSkillResponse2, InvokeSkillError, ThrowOnError>({
    ...options,
    url: '/skill/invoke',
  });
};

/**
 * Stream invoke skill
 * Invoke a skill and return SSE stream
 */
export const streamInvokeSkill = <ThrowOnError extends boolean = false>(
  options: Options<StreamInvokeSkillData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    StreamInvokeSkillResponse,
    StreamInvokeSkillError,
    ThrowOnError
  >({
    ...options,
    url: '/skill/streamInvoke',
  });
};

/**
 * Generate multimedia content
 * Generate image, video or audio based on the given prompt
 */
export const generateMedia = <ThrowOnError extends boolean = false>(
  options: Options<GenerateMediaData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<GenerateMediaResponse, GenerateMediaError, ThrowOnError>({
    ...options,
    url: '/media/generate',
  });
};

/**
 * List copilot sessions
 * List all copilot sessions
 */
export const listCopilotSessions = <ThrowOnError extends boolean = false>(
  options?: Options<ListCopilotSessionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListCopilotSessionsResponse2,
    ListCopilotSessionsError,
    ThrowOnError
  >({
    ...options,
    url: '/copilot/session/list',
  });
};

/**
 * Get copilot session detail
 * Get detail for a copilot session
 */
export const getCopilotSessionDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetCopilotSessionDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCopilotSessionDetailResponse2,
    GetCopilotSessionDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/copilot/session/detail',
  });
};

/**
 * Initialize workflow execution
 * Initialize a new workflow execution for a canvas
 */
export const initializeWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<InitializeWorkflowData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    InitializeWorkflowResponse2,
    InitializeWorkflowError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow/initialize',
  });
};

/**
 * Abort workflow execution
 * Abort a running workflow execution
 */
export const abortWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<AbortWorkflowData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<AbortWorkflowResponse, AbortWorkflowError, ThrowOnError>({
    ...options,
    url: '/workflow/abort',
  });
};

/**
 * List workflow executions
 * List all workflow executions
 */
export const listWorkflowExecutions = <ThrowOnError extends boolean = false>(
  options?: Options<ListWorkflowExecutionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListWorkflowExecutionsResponse2,
    ListWorkflowExecutionsError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow/list',
  });
};

/**
 * Get workflow detail
 * Get detail for a workflow execution
 */
export const getWorkflowDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWorkflowDetailResponse2,
    GetWorkflowDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow/detail',
  });
};

/**
 * Get workflow plan detail
 * Get detail for a workflow plan
 */
export const getWorkflowPlanDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowPlanDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWorkflowPlanDetailResponse2,
    GetWorkflowPlanDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow/plan/detail',
  });
};

/**
 * Create new workflow app
 * Create a new workflow app
 */
export const createWorkflowApp = <ThrowOnError extends boolean = false>(
  options: Options<CreateWorkflowAppData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateWorkflowAppResponse2,
    CreateWorkflowAppError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-app/new',
  });
};

/**
 * Delete workflow app
 * Delete a workflow app
 */
export const deleteWorkflowApp = <ThrowOnError extends boolean = false>(
  options: Options<DeleteWorkflowAppData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteWorkflowAppResponse,
    DeleteWorkflowAppError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-app/delete',
  });
};

/**
 * Get workflow app detail
 * Get detail for a workflow app
 */
export const getWorkflowAppDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowAppDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWorkflowAppDetailResponse2,
    GetWorkflowAppDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-app/detail',
  });
};

/**
 * Execute workflow app
 * Execute a workflow app
 */
export const executeWorkflowApp = <ThrowOnError extends boolean = false>(
  options: Options<ExecuteWorkflowAppData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ExecuteWorkflowAppResponse2,
    ExecuteWorkflowAppError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-app/execute',
  });
};

/**
 * List workflow apps
 * List workflow apps for a user, optionally filtered by canvasId
 */
export const listWorkflowApps = <ThrowOnError extends boolean = false>(
  options?: Options<ListWorkflowAppsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListWorkflowAppsResponse2,
    ListWorkflowAppsError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-app/list',
  });
};

/**
 * Get template generation status
 * Get template generation status for a workflow app
 */
export const getTemplateGenerationStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetTemplateGenerationStatusData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetTemplateGenerationStatusResponse2,
    GetTemplateGenerationStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-app/template-status',
  });
};

/**
 * Create workflow schedule
 * Create a new schedule for workflow execution
 */
export const createSchedule = <ThrowOnError extends boolean = false>(
  options: Options<CreateScheduleData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateScheduleResponse2,
    CreateScheduleError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/create',
  });
};

/**
 * Update workflow schedule
 * Update an existing workflow schedule
 */
export const updateSchedule = <ThrowOnError extends boolean = false>(
  options: Options<UpdateScheduleData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateScheduleResponse2,
    UpdateScheduleError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/update',
  });
};

/**
 * Delete workflow schedule
 * Delete an existing workflow schedule
 */
export const deleteSchedule = <ThrowOnError extends boolean = false>(
  options: Options<DeleteScheduleData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteScheduleResponse2,
    DeleteScheduleError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/delete',
  });
};

/**
 * List workflow schedules
 * Get list of workflow schedules for a canvas
 */
export const listSchedules = <ThrowOnError extends boolean = false>(
  options: Options<ListSchedulesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<ListSchedulesResponse2, ListSchedulesError, ThrowOnError>(
    {
      ...options,
      url: '/schedule/list',
    },
  );
};

/**
 * Get schedule detail
 * Get detailed information about a specific schedule
 */
export const getScheduleDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetScheduleDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetScheduleDetailResponse2,
    GetScheduleDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/detail',
  });
};

/**
 * Get schedule records
 * Get execution records for a specific schedule
 */
export const getScheduleRecords = <ThrowOnError extends boolean = false>(
  options: Options<GetScheduleRecordsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetScheduleRecordsResponse2,
    GetScheduleRecordsError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/records',
  });
};

/**
 * List all schedule records
 * List all schedule execution records with filtering options
 */
export const listAllScheduleRecords = <ThrowOnError extends boolean = false>(
  options: Options<ListAllScheduleRecordsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ListAllScheduleRecordsResponse2,
    ListAllScheduleRecordsError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/records/list',
  });
};

/**
 * Get available tools
 * Get list of tools used in schedule executions
 */
export const getAvailableTools = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetAvailableToolsResponse2,
    GetAvailableToolsError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/records/tools',
  });
};

/**
 * Get schedule record detail
 * Get detailed information about a specific schedule execution record
 */
export const getScheduleRecordDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetScheduleRecordDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetScheduleRecordDetailResponse2,
    GetScheduleRecordDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/record/detail',
  });
};

/**
 * Get record snapshot
 * Get the canvas snapshot for a schedule execution record
 */
export const getRecordSnapshot = <ThrowOnError extends boolean = false>(
  options: Options<GetRecordSnapshotData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetRecordSnapshotResponse2,
    GetRecordSnapshotError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/record/snapshot',
  });
};

/**
 * Trigger schedule manually
 * Manually trigger a schedule execution
 */
export const triggerScheduleManually = <ThrowOnError extends boolean = false>(
  options: Options<TriggerScheduleManuallyData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    TriggerScheduleManuallyResponse2,
    TriggerScheduleManuallyError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/trigger',
  });
};

/**
 * Retry schedule record
 * Retry a failed schedule execution record
 */
export const retryScheduleRecord = <ThrowOnError extends boolean = false>(
  options: Options<RetryScheduleRecordData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    RetryScheduleRecordResponse2,
    RetryScheduleRecordError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/record/retry',
  });
};

/**
 * Enable webhook for a canvas
 * Enable webhook API for a canvas to allow external triggers
 */
export const enableWebhook = <ThrowOnError extends boolean = false>(
  options: Options<EnableWebhookData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<EnableWebhookResponse2, EnableWebhookError, ThrowOnError>(
    {
      ...options,
      url: '/webhook/enable',
    },
  );
};

/**
 * Disable webhook
 * Disable webhook API for a canvas
 */
export const disableWebhook = <ThrowOnError extends boolean = false>(
  options: Options<DisableWebhookData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DisableWebhookResponse,
    DisableWebhookError,
    ThrowOnError
  >({
    ...options,
    url: '/webhook/disable',
  });
};

/**
 * Reset webhook (generate new ID)
 * Reset webhook by generating a new webhook ID
 */
export const resetWebhook = <ThrowOnError extends boolean = false>(
  options: Options<ResetWebhookData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<ResetWebhookResponse2, ResetWebhookError, ThrowOnError>({
    ...options,
    url: '/webhook/reset',
  });
};

/**
 * Update webhook configuration
 * Update webhook configuration
 */
export const updateWebhook = <ThrowOnError extends boolean = false>(
  options: Options<UpdateWebhookData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<UpdateWebhookResponse, UpdateWebhookError, ThrowOnError>({
    ...options,
    url: '/webhook/update',
  });
};

/**
 * Get webhook configuration for a canvas
 * Get webhook configuration including webhook ID and status
 */
export const getWebhookConfig = <ThrowOnError extends boolean = false>(
  options: Options<GetWebhookConfigData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWebhookConfigResponse2,
    GetWebhookConfigError,
    ThrowOnError
  >({
    ...options,
    url: '/webhook/config',
  });
};

/**
 * Get call history for a webhook
 * Get webhook call history with pagination
 */
export const getWebhookHistory = <ThrowOnError extends boolean = false>(
  options: Options<GetWebhookHistoryData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWebhookHistoryResponse2,
    GetWebhookHistoryError,
    ThrowOnError
  >({
    ...options,
    url: '/webhook/history',
  });
};

/**
 * Run workflow via webhook
 * Trigger a webhook to run the linked workflow without authentication.
 *
 * **Request Body Rules**:
 * - If the workflow requires no variables, send an empty body `{}` or `{ "variables": {} }`
 * - If passing variables, they MUST be wrapped in a "variables" field
 * - Do NOT pass variables directly at the top level
 */
export const runWebhook = <ThrowOnError extends boolean = false>(
  options: Options<RunWebhookData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<RunWebhookResponse, RunWebhookError, ThrowOnError>({
    ...options,
    url: '/openapi/webhook/{webhookId}/run',
  });
};

/**
 * Get OpenAPI configuration for a canvas
 * Get OpenAPI configuration including output node settings
 */
export const getOpenapiConfig = <ThrowOnError extends boolean = false>(
  options: Options<GetOpenapiConfigData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetOpenapiConfigResponse,
    GetOpenapiConfigError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/config',
  });
};

/**
 * Update OpenAPI configuration for a canvas
 * Update OpenAPI configuration including output node settings
 */
export const updateOpenapiConfig = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOpenapiConfigData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateOpenapiConfigResponse,
    UpdateOpenapiConfigError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/config',
  });
};

/**
 * Upload files for OpenAPI workflow variables
 * Upload files and get fileKey values for workflow variables. Unused files are cleaned up after about 24 hours.
 */
export const uploadOpenapiFiles = <ThrowOnError extends boolean = false>(
  options: Options<UploadOpenapiFilesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UploadOpenapiFilesResponse,
    UploadOpenapiFilesError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
    url: '/openapi/files/upload',
  });
};

/**
 * Search workflows via API
 * Search workflows accessible by this API key.
 */
export const searchWorkflowsViaApi = <ThrowOnError extends boolean = false>(
  options?: Options<SearchWorkflowsViaApiData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    SearchWorkflowsViaApiResponse,
    SearchWorkflowsViaApiError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/workflows',
  });
};

/**
 * Get workflow detail via API
 * Get workflow details and workflow plan by canvas ID.
 */
export const getWorkflowDetailViaApi = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowDetailViaApiData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWorkflowDetailViaApiResponse,
    GetWorkflowDetailViaApiError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/workflows/{canvasId}',
  });
};

/**
 * Run workflow via API (returns execution ID)
 * Execute a workflow via authenticated API call.
 * Unlike webhook triggers, this endpoint requires API Key authentication
 * and returns an execution ID that can be used to track workflow status.
 *
 * **Request Body Rules**:
 * - If the workflow requires no variables, send an empty body `{}` or `{ "variables": {} }`
 * - If passing variables, they MUST be wrapped in a "variables" field
 * - Do NOT pass variables directly at the top level
 *
 */
export const runWorkflowViaApi = <ThrowOnError extends boolean = false>(
  options: Options<RunWorkflowViaApiData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    RunWorkflowViaApiResponse,
    RunWorkflowViaApiError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/workflow/{canvasId}/run',
  });
};

/**
 * Generate workflow via Copilot
 * Generate a workflow plan from a natural language prompt.
 * If `canvasId` is provided, the workflow on that canvas will be overwritten and cannot be undone.
 *
 */
export const generateWorkflowViaCopilot = <ThrowOnError extends boolean = false>(
  options: Options<GenerateWorkflowViaCopilotData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GenerateWorkflowViaCopilotResponse,
    GenerateWorkflowViaCopilotError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/copilot/workflow/generate',
  });
};

/**
 * Get workflow execution status via API
 * Get workflow execution status via authenticated API call.
 * Requires API Key authentication.
 *
 */
export const getWorkflowStatusViaApi = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowStatusViaApiData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWorkflowStatusViaApiResponse2,
    GetWorkflowStatusViaApiError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/workflow/{executionId}/status',
  });
};

/**
 * Get workflow execution output via API
 * Get workflow execution output (output nodes and drive files) via authenticated API call.
 * Requires API Key authentication.
 * Messages may include partial content while nodes are executing or failed. Files are returned only after nodes finish.
 *
 */
export const getWorkflowOutput = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowOutputData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWorkflowOutputResponse2,
    GetWorkflowOutputError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/workflow/{executionId}/output',
  });
};

/**
 * Abort workflow execution via API
 * Abort a running workflow execution via authenticated API call.
 * Requires API Key authentication.
 *
 */
export const abortWorkflowViaApi = <ThrowOnError extends boolean = false>(
  options: Options<AbortWorkflowViaApiData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    AbortWorkflowViaApiResponse,
    AbortWorkflowViaApiError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/workflow/{executionId}/abort',
  });
};

/**
 * Get user settings
 * Return settings for current user
 */
export const getSettings = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetSettingsResponse, GetSettingsError, ThrowOnError>({
    ...options,
    url: '/user/settings',
  });
};

/**
 * Update user settings
 * Update settings for current user
 */
export const updateSettings = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSettingsData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<UpdateSettingsResponse, UpdateSettingsError, ThrowOnError>(
    {
      ...options,
      url: '/user/settings',
    },
  );
};

/**
 * Check settings field
 * Given a settings field, check if the given value is valid
 */
export const checkSettingsField = <ThrowOnError extends boolean = false>(
  options: Options<CheckSettingsFieldData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    CheckSettingsFieldResponse2,
    CheckSettingsFieldError,
    ThrowOnError
  >({
    ...options,
    url: '/user/checkSettingsField',
  });
};

/**
 * Get form definition
 * Get form definition
 */
export const getFormDefinition = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetFormDefinitionResponse2,
    GetFormDefinitionError,
    ThrowOnError
  >({
    ...options,
    url: '/form/definition',
  });
};

/**
 * Submit form
 * Submit a form
 */
export const submitForm = <ThrowOnError extends boolean = false>(
  options: Options<SubmitFormData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<SubmitFormResponse, SubmitFormError, ThrowOnError>({
    ...options,
    url: '/form/submission',
  });
};

/**
 * Get credit recharge
 * Get credit recharge
 */
export const getCreditRecharge = <ThrowOnError extends boolean = false>(
  options?: Options<GetCreditRechargeData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCreditRechargeResponse2,
    GetCreditRechargeError,
    ThrowOnError
  >({
    ...options,
    url: '/credit/recharge',
  });
};

/**
 * Get credit usage
 * Get credit usage
 */
export const getCreditUsage = <ThrowOnError extends boolean = false>(
  options?: Options<GetCreditUsageData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCreditUsageResponse2,
    GetCreditUsageError,
    ThrowOnError
  >({
    ...options,
    url: '/credit/usage',
  });
};

/**
 * Get credit balance
 * Get credit balance
 */
export const getCreditBalance = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCreditBalanceResponse,
    GetCreditBalanceError,
    ThrowOnError
  >({
    ...options,
    url: '/credit/balance',
  });
};

/**
 * Get credit usage by result ID
 * Get credit usage by result ID
 */
export const getCreditUsageByResultId = <ThrowOnError extends boolean = false>(
  options: Options<GetCreditUsageByResultIdData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCreditUsageByResultIdResponse2,
    GetCreditUsageByResultIdError,
    ThrowOnError
  >({
    ...options,
    url: '/credit/result',
  });
};

/**
 * Get credit usage by execution ID
 * Get credit usage by execution ID
 */
export const getCreditUsageByExecutionId = <ThrowOnError extends boolean = false>(
  options: Options<GetCreditUsageByExecutionIdData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCreditUsageByExecutionIdResponse2,
    GetCreditUsageByExecutionIdError,
    ThrowOnError
  >({
    ...options,
    url: '/credit/execution',
  });
};

/**
 * Get credit usage by canvas ID
 * Get credit usage by canvas ID
 */
export const getCreditUsageByCanvasId = <ThrowOnError extends boolean = false>(
  options: Options<GetCreditUsageByCanvasIdData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCreditUsageByCanvasIdResponse2,
    GetCreditUsageByCanvasIdError,
    ThrowOnError
  >({
    ...options,
    url: '/credit/canvas',
  });
};

/**
 * Get canvas commission by canvas ID
 * Get canvas commission (credit usage with commission rate) by canvas ID
 */
export const getCanvasCommissionByCanvasId = <ThrowOnError extends boolean = false>(
  options: Options<GetCanvasCommissionByCanvasIdData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCanvasCommissionByCanvasIdResponse2,
    GetCanvasCommissionByCanvasIdError,
    ThrowOnError
  >({
    ...options,
    url: '/credit/commission',
  });
};

/**
 * List invitation codes
 * List all invitation codes
 */
export const listInvitationCodes = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListInvitationCodesResponse2,
    ListInvitationCodesError,
    ThrowOnError
  >({
    ...options,
    url: '/invitation/list',
  });
};

/**
 * Activate invitation code
 * Activate an invitation code
 */
export const activateInvitationCode = <ThrowOnError extends boolean = false>(
  options: Options<ActivateInvitationCodeData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ActivateInvitationCodeResponse,
    ActivateInvitationCodeError,
    ThrowOnError
  >({
    ...options,
    url: '/invitation/activate',
  });
};

/**
 * Skip invitation code
 * Skip invitation code and proceed to onboarding without rewards
 */
export const skipInvitationCode = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    SkipInvitationCodeResponse,
    SkipInvitationCodeError,
    ThrowOnError
  >({
    ...options,
    url: '/invitation/skip',
  });
};

/**
 * Get subscription plans
 * Get subscription plans
 */
export const getSubscriptionPlans = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSubscriptionPlansResponse2,
    GetSubscriptionPlansError,
    ThrowOnError
  >({
    ...options,
    url: '/subscription/plans',
  });
};

/**
 * Get subscription usage
 * Get subscription usage
 */
export const getSubscriptionUsage = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSubscriptionUsageResponse2,
    GetSubscriptionUsageError,
    ThrowOnError
  >({
    ...options,
    url: '/subscription/usage',
  });
};

/**
 * List models
 * List all available models
 */
export const listModels = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListModelsResponse2, ListModelsError, ThrowOnError>({
    ...options,
    url: '/subscription/modelList',
  });
};

/**
 * Create checkout session
 * Create a checkout session
 */
export const createCheckoutSession = <ThrowOnError extends boolean = false>(
  options: Options<CreateCheckoutSessionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateCheckoutSessionResponse2,
    CreateCheckoutSessionError,
    ThrowOnError
  >({
    ...options,
    url: '/subscription/createCheckoutSession',
  });
};

/**
 * Create checkout session
 * Create a checkout session
 */
export const createCreditPackCheckoutSession = <ThrowOnError extends boolean = false>(
  options: Options<CreateCreditPackCheckoutSessionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateCreditPackCheckoutSessionResponse,
    CreateCreditPackCheckoutSessionError,
    ThrowOnError
  >({
    ...options,
    url: '/subscription/createCreditPackCheckoutSession',
  });
};

/**
 * Create portal session
 * Create a portal session
 */
export const createPortalSession = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreatePortalSessionResponse2,
    CreatePortalSessionError,
    ThrowOnError
  >({
    ...options,
    url: '/subscription/createPortalSession',
  });
};

/**
 * Search
 * Search for canvases, resources, documents, etc.
 */
export const search = <ThrowOnError extends boolean = false>(
  options: Options<SearchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<SearchResponse2, SearchError, ThrowOnError>({
    ...options,
    url: '/search',
  });
};

/**
 * Multilingual Web Search
 * Search web content across multiple languages
 */
export const multiLingualWebSearch = <ThrowOnError extends boolean = false>(
  options: Options<MultiLingualWebSearchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    MultiLingualWebSearchResponse2,
    MultiLingualWebSearchError,
    ThrowOnError
  >({
    ...options,
    url: '/search/multilingualSearch',
  });
};

/**
 * List providers
 * List all available providers
 */
export const listProviders = <ThrowOnError extends boolean = false>(
  options?: Options<ListProvidersData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListProvidersResponse2, ListProvidersError, ThrowOnError>({
    ...options,
    url: '/provider/list',
  });
};

/**
 * Create provider
 * Create a new provider
 */
export const createProvider = <ThrowOnError extends boolean = false>(
  options: Options<CreateProviderData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateProviderResponse,
    CreateProviderError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/create',
  });
};

/**
 * Update provider
 * Update an existing provider
 */
export const updateProvider = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProviderData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateProviderResponse,
    UpdateProviderError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/update',
  });
};

/**
 * Delete provider
 * Delete an existing provider
 */
export const deleteProvider = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProviderData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteProviderResponse,
    DeleteProviderError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/delete',
  });
};

/**
 * Test provider connection
 * Test provider API connection and availability
 */
export const testProviderConnection = <ThrowOnError extends boolean = false>(
  options: Options<TestProviderConnectionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    TestProviderConnectionResponse2,
    TestProviderConnectionError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/test-connection',
  });
};

/**
 * List provider items
 * List all available provider items
 */
export const listProviderItems = <ThrowOnError extends boolean = false>(
  options?: Options<ListProviderItemsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListProviderItemsResponse2,
    ListProviderItemsError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/item/list',
  });
};

/**
 * List provider item options
 * List all available provider item options for a given provider
 */
export const listProviderItemOptions = <ThrowOnError extends boolean = false>(
  options: Options<ListProviderItemOptionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListProviderItemOptionsResponse2,
    ListProviderItemOptionsError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/item/option/list',
  });
};

/**
 * Create model item
 * Create a new model item
 */
export const createProviderItem = <ThrowOnError extends boolean = false>(
  options: Options<CreateProviderItemData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateProviderItemResponse,
    CreateProviderItemError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/item/create',
  });
};

/**
 * Batch create model items
 * Batch create model items
 */
export const batchCreateProviderItems = <ThrowOnError extends boolean = false>(
  options: Options<BatchCreateProviderItemsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BatchCreateProviderItemsResponse,
    BatchCreateProviderItemsError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/item/batchCreate',
  });
};

/**
 * Update model item
 * Update an existing model item
 */
export const updateProviderItem = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProviderItemData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateProviderItemResponse,
    UpdateProviderItemError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/item/update',
  });
};

/**
 * Batch update provider items
 * Batch update provider items
 */
export const batchUpdateProviderItems = <ThrowOnError extends boolean = false>(
  options: Options<BatchUpdateProviderItemsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BatchUpdateProviderItemsResponse,
    BatchUpdateProviderItemsError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/item/batchUpdate',
  });
};

/**
 * Delete provider item
 * Delete an existing model item
 */
export const deleteProviderItem = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProviderItemData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteProviderItemResponse,
    DeleteProviderItemError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/item/delete',
  });
};

/**
 * List tool
 * List all available tools, including regular tools and MCP servers.
 */
export const listTools = <ThrowOnError extends boolean = false>(
  options?: Options<ListToolsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListToolsResponse2, ListToolsError, ThrowOnError>({
    ...options,
    url: '/tool/list',
  });
};

/**
 * List user tools
 * Get installed tools and unauthorized external OAuth tools for current user.
 */
export const listUserTools = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListUserToolsResponse2, ListUserToolsError, ThrowOnError>({
    ...options,
    url: '/tool/user/list',
  });
};

/**
 * List toolset inventory
 * List all available toolsets in inventory, including uninstalled.
 */
export const listToolsetInventory = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListToolsetInventoryResponse2,
    ListToolsetInventoryError,
    ThrowOnError
  >({
    ...options,
    url: '/tool/inventory/list',
  });
};

/**
 * List toolsets
 * List all installed toolsets
 */
export const listToolsets = <ThrowOnError extends boolean = false>(
  options?: Options<ListToolsetsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListToolsetsResponse2, ListToolsetsError, ThrowOnError>({
    ...options,
    url: '/tool/toolset/list',
  });
};

/**
 * Create regular tool
 * Create a new regular tool
 */
export const createToolset = <ThrowOnError extends boolean = false>(
  options: Options<CreateToolsetData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<CreateToolsetResponse, CreateToolsetError, ThrowOnError>({
    ...options,
    url: '/tool/toolset/create',
  });
};

/**
 * Update toolset
 * Update an existing toolset
 */
export const updateToolset = <ThrowOnError extends boolean = false>(
  options: Options<UpdateToolsetData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<UpdateToolsetResponse, UpdateToolsetError, ThrowOnError>({
    ...options,
    url: '/tool/toolset/update',
  });
};

/**
 * Delete toolset
 * Delete an existing toolset
 */
export const deleteToolset = <ThrowOnError extends boolean = false>(
  options: Options<DeleteToolsetData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<DeleteToolsetResponse, DeleteToolsetError, ThrowOnError>({
    ...options,
    url: '/tool/toolset/delete',
  });
};

/**
 * Export toolset definitions
 * Export tool schemas for specified toolsets. Used for generating Python SDK.
 */
export const exportToolsetDefinitions = <ThrowOnError extends boolean = false>(
  options?: Options<ExportToolsetDefinitionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ExportToolsetDefinitionsResponse2,
    ExportToolsetDefinitionsError,
    ThrowOnError
  >({
    ...options,
    url: '/tool/toolset/exportDefinitions',
  });
};

/**
 * Execute tool
 * Execute a tool by toolset key and tool name.
 */
export const executeTool = <ThrowOnError extends boolean = false>(
  options: Options<ExecuteToolData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<ExecuteToolResponse2, ExecuteToolError, ThrowOnError>({
    ...options,
    url: '/tool/execute',
  });
};

/**
 * Get tool call result
 * Get the result of a tool call
 */
export const getToolCallResult = <ThrowOnError extends boolean = false>(
  options: Options<GetToolCallResultData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetToolCallResultResponse2,
    GetToolCallResultError,
    ThrowOnError
  >({
    ...options,
    url: '/tool/call/result',
  });
};

/**
 * Authorize Composio connection
 * Generate an OAuth authorization URL for a Composio integration.
 */
export const authorizeComposioConnection = <ThrowOnError extends boolean = false>(
  options: Options<AuthorizeComposioConnectionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    AuthorizeComposioConnectionResponse,
    AuthorizeComposioConnectionError,
    ThrowOnError
  >({
    ...options,
    url: '/tool/composio/{app}/authorize',
  });
};

/**
 * Revoke Composio connection
 * Revoke a user's Composio connection and reset OAuth state.
 */
export const revokeComposioConnection = <ThrowOnError extends boolean = false>(
  options: Options<RevokeComposioConnectionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    RevokeComposioConnectionResponse,
    RevokeComposioConnectionError,
    ThrowOnError
  >({
    ...options,
    url: '/tool/composio/{app}/revoke',
  });
};

/**
 * Get Composio connection status
 * Query the current Composio connection status for a user by app slug.
 */
export const getComposioConnectionStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetComposioConnectionStatusData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetComposioConnectionStatusResponse,
    GetComposioConnectionStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/tool/composio/{app}/status',
  });
};

/**
 * Scrape
 * Scrape a weblink
 */
export const scrape = <ThrowOnError extends boolean = false>(
  options: Options<ScrapeData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<ScrapeResponse, ScrapeError, ThrowOnError>({
    ...options,
    url: '/misc/scrape',
  });
};

/**
 * Upload
 * Upload a file
 */
export const upload = <ThrowOnError extends boolean = false>(
  options: Options<UploadData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<UploadResponse2, UploadError, ThrowOnError>({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
    url: '/misc/upload',
  });
};

/**
 * Serve static
 * Serve static files (only for local testing)
 */
export const serveStatic = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ServeStaticResponse, ServeStaticError, ThrowOnError>({
    ...options,
    url: '/misc/static/{fileName}',
  });
};

/**
 * Convert between formats
 * Convert content between different formats (e.g., HTML to Markdown)
 */
export const convert = <ThrowOnError extends boolean = false>(
  options: Options<ConvertData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<ConvertResponse2, ConvertError, ThrowOnError>({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
    url: '/misc/convert',
  });
};

/**
 * Get prompt suggestions
 * Get prompt suggestions for a given user
 */
export const getPromptSuggestions = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetPromptSuggestionsResponse2,
    GetPromptSuggestionsError,
    ThrowOnError
  >({
    ...options,
    url: '/misc/promptSuggestions',
  });
};

/**
 * Get available vouchers
 * Get user's available (unused, not expired) vouchers
 */
export const getAvailableVouchers = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetAvailableVouchersResponse2,
    GetAvailableVouchersError,
    ThrowOnError
  >({
    ...options,
    url: '/voucher/available',
  });
};

/**
 * List user vouchers
 * List all vouchers for the current user
 */
export const listUserVouchers = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListUserVouchersResponse2,
    ListUserVouchersError,
    ThrowOnError
  >({
    ...options,
    url: '/voucher/list',
  });
};

/**
 * Validate voucher
 * Validate a voucher before use
 */
export const validateVoucher = <ThrowOnError extends boolean = false>(
  options: Options<ValidateVoucherData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ValidateVoucherResponse2,
    ValidateVoucherError,
    ThrowOnError
  >({
    ...options,
    url: '/voucher/validate',
  });
};

/**
 * Create voucher invitation
 * Create a sharing invitation for a voucher
 */
export const createVoucherInvitation = <ThrowOnError extends boolean = false>(
  options: Options<CreateVoucherInvitationData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateVoucherInvitationResponse2,
    CreateVoucherInvitationError,
    ThrowOnError
  >({
    ...options,
    url: '/voucher/invitation/create',
  });
};

/**
 * Verify invitation code
 * Verify an invitation code (public endpoint)
 */
export const verifyVoucherInvitation = <ThrowOnError extends boolean = false>(
  options: Options<VerifyVoucherInvitationData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    VerifyVoucherInvitationResponse2,
    VerifyVoucherInvitationError,
    ThrowOnError
  >({
    ...options,
    url: '/voucher/invitation/verify',
  });
};

/**
 * Claim invitation
 * Claim an invitation and receive a voucher
 */
export const claimVoucherInvitation = <ThrowOnError extends boolean = false>(
  options: Options<ClaimVoucherInvitationData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ClaimVoucherInvitationResponse2,
    ClaimVoucherInvitationError,
    ThrowOnError
  >({
    ...options,
    url: '/voucher/invitation/claim',
  });
};

/**
 * Trigger voucher generation
 * Trigger voucher generation on template publish. Scores the template and generates a discount voucher.
 */
export const triggerVoucher = <ThrowOnError extends boolean = false>(
  options: Options<TriggerVoucherData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    TriggerVoucherResponse2,
    TriggerVoucherError,
    ThrowOnError
  >({
    ...options,
    url: '/voucher/trigger',
  });
};
